import styled from 'styled-components';

export const PayrollSyncPanelRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

export const PayrollSyncDescription = styled.div`
  white-space: pre-line;
`;

export const PayrollSyncButtonHost = styled.div`
  display: flex;
`;
